module.exports = __webpack_public_path__ + "static/media/event-planner.ccd44aea.jpg";